import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Box,
  Typography
} from '@mui/material';
import { Done, Close } from '@mui/icons-material';
import { ChangeRequest } from '@/api/bol/models';

interface PatchChangeRequestDialogProps {
  open: boolean;
  onClose: () => void;
  onPatch: (status: 'ACCEPTED' | 'REJECTED') => Promise<void>;
  changeRequest: ChangeRequest | null;
  error: string | null;
  patching: boolean;
}

export const PatchChangeRequestDialog: React.FC<PatchChangeRequestDialogProps> = ({
  open,
  onClose,
  onPatch,
  changeRequest,
  error,
  patching
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Change Request Status</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        {changeRequest && (
          <Box>
            <Typography variant="body2" sx={{ mb: 2 }}>
              <strong>Change Request ID:</strong> {changeRequest.id}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              <strong>Current Status:</strong> {changeRequest.status}
            </Typography>
            <Typography variant="body2" sx={{ mb: 3 }}>
              <strong>Description:</strong> {changeRequest.description || 'No description'}
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Choose an action:
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button onClick={onClose} variant="outlined">Cancel</Button>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            onClick={() => onPatch('REJECTED')}
            disabled={patching}
            variant="outlined"
            color="error"
            startIcon={<Close />}
          >
            Reject
          </Button>
          <Button
            onClick={() => onPatch('ACCEPTED')}
            disabled={patching}
            variant="contained"
            color="success"
            startIcon={<Done />}
          >
            {patching ? 'Updating...' : 'Accept'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
